export default __webpack_public_path__ + "static/media/target2.a92b5610.svg";